export default __webpack_public_path__ + "static/media/Outgoing_call.99e8bff8.svg";